export default __webpack_public_path__ + "static/media/websitedesign.ac3ac7de.gif";